// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"96c7da94","658":"00af3359","787":"ae17d97f"}[chunkId] + ".chunk.js";
};